import _ from "lodash";
/** external **/
import React from "react";
import { graphql, compose } from "lib/apolloClient";

/** internal **/
import { getAIConversationsQuery } from "Worksheet/modules/WorksheetQueries";
import { getAIConversationsFromCache } from "Worksheet/modules/WorksheetGraphqlHelpers";
import AiQuestionGeneratorV2 from "./AiQuestionGeneratorV2";

const AiQuestionGeneratorWrapper = props => {
  return <AiQuestionGeneratorV2 {...props} />;
};

export default compose(
  graphql(getAIConversationsQuery, {
    name: "getAIConversations",
    skip: ({ aiConversationId }) => _.isEmpty(aiConversationId),
    options: ({ aiConversationId, portalType }) => ({
      fetchPolicy: "cache-and-network",
      variables: { id: aiConversationId, portalType },
      context: {
        useHttpLink: true,
      },
    }),
    props({ getAIConversations }) {
      const queryData = getAIConversationsFromCache(
        getAIConversations.variables
      );
      const networkStatus = _.get(getAIConversations, "networkStatus");

      const conversationMetadata = _.get(queryData, "metadata", {});
      const conversationAttachments = _.get(queryData, "attachments", []);

      return {
        isData: !_.isEmpty(queryData),
        isLoading: _.includes([1, 2], networkStatus),
        conversationMetadata,
        conversationAttachments,
      };
    },
  })
)(AiQuestionGeneratorWrapper);
